// extracted by mini-css-extract-plugin
module.exports = {"copyable-icon":"style_copyable-icon__dDDKe"};